import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { AdminIcon, type AdminIconName } from '@/features/admin/icons';
import { Skeleton } from '@/features/ui/skeleton';
import '@/features/admin/admin.css';

export function AdminPageHeader({
  description,
  actions,
}: {
  title: string;
  description?: string;
  actions?: ReactNode;
}) {
  if (!description && !actions) return null;

  return (
    <header className="admin-page-header">
      {description ? (
        <div>
          <p>{description}</p>
        </div>
      ) : null}
      {actions ? <div className="admin-page-actions">{actions}</div> : null}
    </header>
  );
}

export function AdminEmpty({
  icon = 'inbox',
  title,
  hint,
}: {
  icon?: AdminIconName;
  title: string;
  hint?: string;
}) {
  return (
    <div className="admin-empty">
      <AdminIcon name={icon} size={36} />
      <div>
        <strong>{title}</strong>
        {hint ? <span className="muted">{hint}</span> : null}
      </div>
    </div>
  );
}

export function AdminKpiCard({
  to,
  label,
  value,
  hint,
  icon,
  tone = 'default',
}: {
  to: string;
  label: string;
  value: number | string;
  hint?: string;
  icon: AdminIconName;
  tone?: 'default' | 'warn' | 'ok' | 'danger';
}) {
  return (
    <Link to={to} className="admin-kpi">
      <div className="admin-kpi-top">
        <span className={`admin-kpi-icon${tone !== 'default' ? ` ${tone}` : ''}`}>
          <AdminIcon name={icon} size={18} />
        </span>
      </div>
      <p className="admin-kpi-label">{label}</p>
      <p className="admin-kpi-value">{value}</p>
      {hint ? <p className="admin-kpi-hint">{hint}</p> : null}
    </Link>
  );
}

export function AdminLoadingGrid({ count = 4 }: { count?: number }) {
  return (
    <div className="admin-kpi-grid" role="status" aria-label="Chargement">
      {Array.from({ length: count }, (_, i) => (
        <Skeleton key={i} variant="card" height="5.5rem" />
      ))}
    </div>
  );
}
